/* eslint-disable react/forbid-prop-types */
import React, { useRef, useEffect, useState } from 'react';
import { Button, SnapDialog } from '@one-snap/sparkles';
import { Divider } from '@mui/material';
import PropTypes from 'prop-types';
import './AgreementPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function AgreementPage({
  isVisible,
  onClose,
  totalAmount,
  goBack,
  onContinue,
  agreementData,
  loading
}) {
  const termsDivRef = useRef(null);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    if (agreementData?.data?.agreementInformation?.agreementDetails) {
      const sanitizedHtml =
        agreementData.data.agreementInformation.agreementDetails
          .replace(/\\n/g, '\n')
          .replace(/\\t/g, '\t')
          .replace(/\\"/g, '"');

      setHtmlContent(sanitizedHtml); // Set content to state
    }
  }, [agreementData]);

  useEffect(() => {
    if (termsDivRef.current && htmlContent) {
      termsDivRef.current.innerHTML = htmlContent;
    }
  }, [htmlContent]);

  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        style: {
          width: '850px',
          maxWidth: '850px',
          padding: '0px !important'
        }
      }}
    >
      <div className="agree-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="review-agreement-title">
            Review and sign your agreement
          </div>
          <div className="review-agreement-subtitle">
            Carefully review the entire agreement before signing.
          </div>
          <br />
          <br />
          <Divider />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div className="terms-doc-ref" ref={termsDivRef} />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div className="imp-card">
            <div className="imp-card-internal">
              <div className="imp-title">Important</div>
              <div>
                By signing the agreement, you agree to the terms of this
                agreement which include important lease-to-own disclosures, ACH
                authorization, jury trial waiver, and arbitration clause.
              </div>
              <Button
                className="continue-button"
                onClick={onContinue}
                loading={loading}
              >
                Sign Agreement
              </Button>
            </div>
          </div>
          <br />
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

AgreementPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  agreementData: PropTypes.object.isRequired
};

export default AgreementPage;
